<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-form
            v-model="valid"
            lazy-validation
            ref="form"
            id="new-patient-form">
    <v-layout
      justify-center
      wrap
    >

      <v-flex
        xs12
        md8
      >

        <material-card
          color="green"
          title="معلومات المراجع"
          text="يرجى ادخال معلومات المراجع و الاسم بشكل صحيح"
        >

            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="fullname"

                    :rules="[rules.required]"
                    label="إسم الطفل الرباعي"

                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="mothername"
                    class="purple-input"
                    required
                    :rules="[rules.required]"
                    label="إسم الأم الرباعي"></v-text-field>
                </v-flex>
               <v-flex
                   xs12
                   md4>
                   <v-autocomplete
                           required
                           :items="this.$store.state.iraqprovs"
                           v-model="province"
                           item-text="text"
                           label="المحافظة">
                   </v-autocomplete>
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="district"
                    required
                    :rules="Rules('nameRules')"
                    label="القضاء"
                    class="purple-input">

                  </v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    v-model="sector"
                    required
                    :rules="Rules('numberRules')"
                    label="المحلة"
                    class="purple-input"></v-text-field>
                </v-flex>

                <v-flex
                  xs12
                  md4
                >

                <v-text-field
                    v-model="street"
                    required
                    :rules="Rules('numberRules')"
                    label="الزقاق"
                    class="purple-input"></v-text-field>
                </v-flex>

                <v-flex
                  xs12
                  md4>
                  <v-text-field
                    v-model="houseno"
                    required
                    :rules="Rules('numberRules')"
                    label="الدار"
                    class="purple-input"></v-text-field>
                </v-flex>

                <v-flex
                  xs12
                  md4>
                    <v-autocomplete
                            :items="this.$store.state.sexitems"
                            v-model="sex"
                            label="الجنس"
                    >
                    </v-autocomplete>

                </v-flex>

                <v-flex
                   xs12
                   md4>

                      <v-autocomplete
                              :items="this.$store.state.pregages"
                              :rules="[v => !!v || 'الحقل مطلوب']"
                              v-model="pregage"
                              class="purple-input"
                              label="العمر الحملي"/>

                </v-flex>

                <v-flex
                        xs12
                        md4>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-text-field aria-autocomplete="none"
                              v-on="on"
                              :rules="[rules.required]"
                              readonly
                              v-model="birthdate"
                              class="purple-input"
                              label="تاريخ الميلاد"/>
                    </template>
                    <v-date-picker :max="max_date" :min="min_date"  v-model="birthdate" />
                  </v-menu>
                </v-flex>

                <v-flex
                        xs12
                        md4>
                  <v-text-field
                        v-model="mobile"
                        class="purple-input"
                        label="رقم الهاتف"
                        :rules="[rules.phonecounter, rules.required]"
                        required
                  />
                </v-flex>



                <v-flex
                        xs12
                        md4>
                  <v-checkbox
                  v-model="twin"
                          label="تؤام ؟"
                          color="success"
                          value="1"
                  />
                </v-flex>



                <v-flex xs12>
                  <v-textarea

                    class="purple-input"
                    label="ملاحظات عامة"
                  />
                </v-flex>

              </v-layout>
            </v-container>

        </material-card>
      </v-flex>
      <v-flex
        xs12
        md4
      >
        <material-card
          color="green"
          title="معلومات العينة"
          text="يرجى ادخال معلومات العينة بشكل كامل">
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                    xs12
                    md12>
                  <v-text-field
                    v-model="barcode"
                    class="purple-input"
                    label="رقم العينة"
                    :rules="Rules('barcodenumberRules')"
                    required></v-text-field>
                </v-flex>

              <v-flex
                   xs12
                   md12>

                  <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                          <v-text-field aria-autocomplete="none"
                                        v-on="on"
                                        :rules="[rules.required]"
                                        readonly
                                        v-model="takendate"
                                        class="purple-input"
                                        label="تاريخ اخذ العينة"></v-text-field>
                      </template>
                      <v-date-picker v-model="takendate" :max="max_date" :min="min_date">

                      </v-date-picker>
                  </v-menu>
              </v-flex>
              <v-flex
                  xs12
                  md12>
                <v-text-field
                    class="purple-input"
                    v-model="takenby"
                    label="إسم القائم بأخذ العينة"
                    :rules="Rules('nameRules')"
                    required
                />
              </v-flex>


                <v-flex
                   xs12
                   md12>
                  <v-autocomplete
                            :items="healthdeps"
                            v-model="healthdep"
                            label="دائرة الصحة"
                            class="purple-input"
                            required></v-autocomplete>
                </v-flex>
                <v-flex
                        xs12
                        md12>
                  <v-text-field
                            class="purple-input"
                            v-model="healthsector"
                            label="القطاع"
                            name="text"
                            :rules="Rules('nameRules')"
                            required
                  />
                </v-flex>
                <v-flex
                        xs12
                        md12>
                  <v-text-field
                            v-model="healthcenter"
                            class="purple-input"
                            label="المركز الصحي"
                            :rules="Rules('nameRules')"
                            required
                  />
                </v-flex>


                <v-flex
                    xs12
                    md12>
                  <v-autocomplete
                      :items="this.$store.state.checktypes"
                      v-model="status"
                      label="نوع الفحص"
                      class="purple-input"
                      ></v-autocomplete>
                </v-flex>


                <v-flex
                        xs12
                        md12>

                  <v-checkbox
                            v-model="duplicate"
                            label="عينة مكررة ؟"
                            color="success"
                            value="1"
                  />
                </v-flex>

                <v-flex
                    xs12
                    md12>
                  <v-checkbox
                      v-model="rejected"
                      label="عينة مرفوضة ؟"
                      color="success"
                      value="1"
                  />
                </v-flex>



                <v-flex
                        xs12
                        md12>

                  <v-text-field
                            v-model="duplicatereason"
                            class="purple-input"
                            label="سبب تكرار / رفض العينة"/>
                </v-flex>

              </v-layout>
            </v-container>


        </material-card>
        </v-flex>
          <v-flex
                  md12
                  xs12
                  text-xs-right
                    >
                    <v-btn
                            x-large
                            block
                            @click="validateFunc"
                            :disabled="!valid"
                            form="new-patient-form"
                            class="mx-0 font-weight-bold"
                            color="success"
                    >
              إضافة القيد
            </v-btn>
          </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import Axios from 'axios'
import {__GET_AS_LIST} from '@/utils/utils'
  export default {
    computed: {

    },
    data: () => ({
      max_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      min_date: '2020-01-01',
      // Validation Rules
      rules: {
        required: value => !!value || 'هذا الحقل مطلوب',
        counter: value => value.length <= 40 || 'الحد الأقصى هو 40 حرف',
        phonecounter: value =>  {
          const pattern = /^0?7[0-9]{9,9}$/;

          return pattern.test(value) || 'رقم الهاتف غير صحيح'
        },
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'البريد الالكتروني غير صحيح'
        },
        strength: value => {
          const pattern = /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})/
          return pattern.test(value) || 'يجب ان تكون كلمة السر مكونة حروف كبيرة، حروف صغيرة,ارقام , علامات خاصةو لاتقل عن ٦ ارقام او حروف'
        },
      },
      fullname: '',
      valid: true,
      picker: new Date().toISOString().substr(0, 10),
      date: new Date().toISOString().substr(0, 10),
      birthtime: '',
      healthcenter: '',
      healthsector: '',
      sex: '',
      district: '',
      duplicatereason: '',
      healthdep: '',
      status: '1',
      takenby: '',
      takendate: '',
      barcode: '',
      mobile: '',
      birthdate: '',
      houseno: '',
      street: '',
      sector: '',
      province: null,
      mothername: '',
      menu: false,
      modal: false,
      menu2: false,
      pregage: null,
      twin: 0,
      duplicate: 0,
      rejected: 0,
      healthdeps:[],

    }),
      created() { this.getHealthDep() },
    methods: {
        Rules(type) {
            return this.$store.state.appRules[type];
            },
      validateFunc() {
        //console.log("btnClicked")
        if (this.$refs.form.validate()) {
          this.submitForm()
        }
      },
        getHealthDep() {
            __GET_AS_LIST("healthdep",{},(res) => {
                res.map((i) => {
                   // console.log("xcxcx",i);
                    this.healthdeps.push({text: i.title, value:i.id});
                });
            });

        },
      submitForm() {
        Axios.post("https://cphl.esite-lab.com/api.php?do=newpatient",{
          birthtime: this.birthtime,
          fullname: this.fullname,
          healthcenter: this.healthcenter,
          healthsector: this.healthsector,
          sex: this.sex,
          district: this.district,
          duplicatereason: this.duplicatereason,
          healthdep: this.healthdep,
          takenby: this.takenby,
          takendate: this.takendate,
          barcode: this.barcode,
          mobile: this.mobile,
          birthdate: this.birthdate,
          houseno: this.houseno,
          street: this.street,
          sector: this.sector,
          province: this.province,
          mothername: this.mothername,
          pregage: this.pregage,
          twin: this.twin,
          birthplace: '',
          duplicate: this.duplicate ? 1 : 0,
          status: this.status,
          rejected: this.rejected ? 1 : 0,
        }, {
          headers: {
            'Content-Type': "application/x-www-form-urlencoded"
          }
        }).then((res) => {
            if (res.data.auth == true) {
              this.$router.push({path: '/list-patients'})
            }
        })
      }
    }
  }
</script>
